export const creditsApiSelector = state => state.api.credits;
